import { render, staticRenderFns } from "./ToDoTaskForm.vue?vue&type=template&id=791bb54e&scoped=true"
import script from "./ToDoTaskForm.vue?vue&type=script&lang=js"
export * from "./ToDoTaskForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791bb54e",
  null
  
)

export default component.exports